import styled from 'styled-components';
import { getContrastColor } from '../../utils/colorUtils';
import { tooltipMixin } from '../../styles/tooltipMixin';

/* ─── Layout ─────────────────────────────────────────────── */
/*padding: max(10px, 2.5vw) max(15px, 2vw) 80px;*/
export const PageWrapper = styled.div`
  width: calc(100% + 40px);
  margin-left: -20px;
  margin-right: -20px;

  min-height: 80vh;
`;

export const HeaderCard = styled.div`
  background: ${p => p.bg};
  border: 1px solid ${p => p.accent}55;
  border-radius: 12px;
  padding: 20px 24px;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;       /* una sola columna */
    grid-template-areas:
      "userinfo"
      "search"
      "actions";
    gap: 12px;
    padding: 16px;
  }
`;

export const UserInfo = styled.div`
  display: flex; 
  align-items: center; 
  gap: 14px;
`;

export const Avatar = styled.img`
  width: 56px; 
  height: 56px; 
  border-radius: 10px;
  object-fit: contain; 
  flex-shrink: 0;
`;

export const UserMeta  = styled.div`
  display: flex; 
  flex-direction: column; 
  gap: 2px;
`;
export const UserName  = styled.h1`
  color: ${p => getContrastColor(p.bg)}; 
  font-size: 20px; 
  font-weight: 700; 
  margin: 0;
`;
export const UserSub   = styled.p`
  color: ${p => getContrastColor(p.bg)}88; 
  font-size: 13px; 
  margin: 0;
`;
export const HeaderRight = styled.div`
  display: flex; 
  align-items: center; 
  gap: 12px; 
  justify-self: end; 
  grid-column: 3;
  @media (max-width: 640px) {
    max-width: 100%;
    grid-column: 1;
    justify-self: stretch;
    justify-content: space-between;
    width: 100%;
  }

`;
export const CountBadge  = styled.div`color: ${p => p.accent}; font-size: 14px; font-weight: 500;`;

export const AddBtn = styled.button`
  background: ${p => p.accent}; 
  color: #fff; 
  border: none;
  border-radius: 8px; 
  padding: 10px 18px; 
  font-size: 14px; 
  font-weight: 600;
  cursor: pointer; 
  transition: all 0.2s;
  &:hover { opacity: 0.85; transform: translateY(-1px); }
`;

export const ToggleBtn = styled.button`
  background: transparent; color: ${p => p.accent};
  border: 1px solid ${p => p.accent}88; 
  border-radius: 8px;
  padding: 8px 12px; 
  font-size: 13px; 
  font-weight: 600;
  cursor: pointer; 
  transition: all 0.2s;
  display: flex; align-items: center; 
  gap: 6px;
  &:hover { background: ${p => p.accent}22; border-color: ${p => p.accent}; }
`;

/* ─── Grids ──────────────────────────────────────────────── */

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, var(--card-w, clamp(180px, 13vw, 280px)));
  justify-content: center;
  gap: 10px;
  padding: 10px;

@media (max-width: 600px) {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 8px;
  
}
`;


export const FlatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, var(--card-w, clamp(180px, 13vw, 280px)));
  justify-content: center;
  gap: 10px;

  @media (max-width: 600px) {
    /* CAMBIO CLAVE: minmax(0, 1fr) obliga a que las 2 columnas midan el 50% exacto del móvil */
    grid-template-columns: repeat(2, minmax(0, 1fr)); 
    padding: 12px 8px 80px;
    gap: 8px; /* Simplificado para móvil */
  }

`;

/* ─── Tarjeta plana ──────────────────────────────────────── */

export const FlatCard = styled.div`
  position: relative; 
  width: var(--card-w, clamp(180px, 13vw, 280px)); 
  border-radius: 10px;
  overflow: hidden; 
  cursor: pointer;
  background: ${p => p.bg}; 
  border: 2px solid rgb(247, 247, 251);
  &:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.35); }
  &:hover .card-actions { opacity: 1; }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const FlatImg = styled.img`
  width: 100%; 
  height: var(--card-h1, 210px); 
  object-fit: cover; 
  display: block;
`;

export const FlatInfo = styled.div`
  padding: 6px 10px; 
  display: flex; 
  flex-direction: column; 
  gap: 3px;
  border-top: 2px solid rgb(247, 247, 251);
`;

export const FlatPrice  = styled.div`
  font-size: 15px; 
  font-weight: 800; 
  color: ${p => p.accent}; 
  line-height: 1.1; 
  margin-bottom: 1px;
`;
export const FlatNombre = styled.div`
  font-size: 14px; 
  font-weight: 700; 
  color: ${p => p.color}; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis;
`;
export const FlatDesc   = styled.div`
  font-size: 12px; 
  color: ${p => p.color}; 
  opacity: 0.65; 
  display: -webkit-box; 
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical; 
  overflow: hidden; 
  line-height: 1.4;

`;
export const FlatExtras = styled.div`
  font-size: 12px; 
  color: ${p => p.color}; 
  opacity: 0.75; 
  margin-top: 2px;
`;

export const FlatBadges = styled.div`
  display: flex; 
  gap: 5px; 
  flex-wrap: nowrap; 
  margin-top: 3px;
`;
export const FlatBadge  = styled.span`
  font-size: 12px; 
  font-weight: 600; 
  padding: 2px 8px; 
  border-radius: 10px; 
  background: ${p => p.accent}22; 
  color: ${p => p.accent}; 
  border: 1px solid ${p => p.accent}44; 
  white-space: nowrap;
`;

/* ─── Tarjeta agrupada ───────────────────────────────────── */

export const CardPrice  = styled(FlatPrice)`font-size: 14px;`;
export const CardDesc   = styled(FlatDesc)`font-size: 12px;`;
export const CardExtras = styled(FlatExtras)`font-size: 12px;`;

export const CardOuter = styled.div`
  position: relative;
  width: var(--card-w, clamp(180px, 13vw, 280px));
  ${tooltipMixin('center')}

  @media (max-width: 600px) {
    width: 100%;
  }
`;
export const CardWrapper = styled.div`
  position: relative; 
  cursor: pointer;
  overflow: hidden;
  border-radius: 10px;
  background: ${p => p.bg};
  border: 2px solid rgb(247, 247, 251);
  display: flex;             
  flex-direction: column;    
  &:hover .card-actions { opacity: 1; }
  &:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.35); }
`;

export const CardActions = styled.div`
  position: absolute;
  top: 0; 
  left: 0; 
  right: 0; 
  bottom: 0;
  background: rgba(0,0,0,0.55); 
  border-radius: 8px 8px 0 0;
  display: flex; 
  flex-direction: column; align-items: center; 
  justify-content: flex-end;
  gap: 0; padding-bottom: 14px;
  opacity: 0; 
  transition: opacity 0.2s; z-index: 10;
`;

export const ActionBtn = styled.button`
  background: ${p => p.danger ? '#e74c3c' : p.accent};
  color: #fff; 
  border: none;
  border-radius: 6px;
  padding: 8px 14px; 
  font-size: 13px; 
  font-weight: 600;
  cursor: pointer; 
  transition: all 0.2s;
  &:hover { opacity: 0.85; }
`;

/* ─── Estado vacío ───────────────────────────────────────── */

export const EmptyState = styled.div`
  display: flex; 
  flex-direction: column;
  align-items: center; 
  justify-content: center;
  min-height: 40vh; 
  gap: 14px; 
  text-align: center;
`;

export const EmptyIcon  = styled.div`font-size: 64px;`;
export const EmptyTitle = styled.h2`color: ${p => getContrastColor(p.bg)}; font-size: 20px; margin: 0;`;
export const EmptySub   = styled.p`color: ${p => getContrastColor(p.bg)}77; font-size: 15px; margin: 0;`;

/* ─── Pantalla protegida ─────────────────────────────────── */

export const ProtectedScreen = styled.div`
  display: flex; 
  flex-direction: column;
  align-items: center; 
  justify-content: center;
  min-height: 60vh; 
  gap: 16px; 
  text-align: center;
`;

/* ─── Overlay ────────────────────────────────────────────── */

export const Overlay = styled.div`
  position: fixed; 
  inset: 0;
  background: rgba(0,0,0,0.75);
  display: flex; 
  align-items: center; 
  justify-content: center;
  z-index: 1000; 
  padding: 20px;
`;

/* ─── Modal confirmación eliminar ────────────────────────── */

export const ConfirmBox = styled.div`
  background: ${p => p.bg}; 
  border: 2px solid rgba(255,255,255,0.12);
  border-radius: 12px; 
  padding: 28px 32px;
  max-width: 360px; 
  width: 90%; 
  text-align: center;
`;

export const ConfirmTitle = styled.p`
  color: ${p => getContrastColor(p.bg)};
  font-size: 16px; 
  font-weight: 600; 
  margin: 0 0 20px;
`;

export const ConfirmActions = styled.div`display: flex; gap: 10px; justify-content: center;`;

/* ─── Modal detalle ──────────────────────────────────────── */

export const DetailBox = styled.div`
  background: ${p => p.bg}; 
  border: 2px solid rgba(255,255,255,0.12);
  border-radius: 14px;
  max-width: 700px; 
  width: 95%; 
  max-height: 90vh;
  overflow: visible; 
  position: relative;
  display: flex; 
  flex-direction: column;
`;

export const DetailScroll = styled.div`
  overflow-y: auto; 
  padding: 32px;
  display: flex; 
  flex-direction: column; 
  gap: 20px;
  max-height: 90vh; 
  border-radius: 14px;
`;

export const DetailClose = styled.button`
  position: absolute; 
  top: 12px; 
  right: 12px;
  background: rgba(255,255,255,0.1); 
  border: none; 
  color: #fff;
  font-size: 20px; 
  width: 34px; 
  height: 34px; 
  border-radius: 50%;
  cursor: pointer; 
  display: flex; 
  align-items: center; 
  justify-content: center;
  &:hover { background: rgba(255,255,255,0.2); }
`;

export const DetailTitle   = styled.h2`color: ${p => p.color}; font-size: 22px; font-weight: 700; margin: 0; padding-right: 40px;`;
export const DetailActions = styled.div`display: flex; gap: 10px; align-items: center; justify-content: space-between;`;
export const DetailPrice   = styled.div`font-size: 26px; font-weight: 800; color: ${p => p.accent};`;

export const DetailMeta = styled.div`display: flex; gap: 8px; flex-wrap: wrap; align-items: center;`;

export const MetaTag = styled.span`
  font-size: 12px; font-weight: 600; padding: 3px 10px; border-radius: 12px;
  background: ${p => p.accent ? p.accent + '22' : 'rgba(255,255,255,0.08)'};
  color: ${p => p.accent ? p.accent : 'rgba(255,255,255,0.7)'};
  border: 1px solid ${p => p.accent ? p.accent + '44' : 'rgba(255,255,255,0.15)'};
`;

export const DetailDesc = styled.p`
  color: ${p => p.color}bb; font-size: 14px;
  line-height: 1.6; margin: 0; white-space: pre-wrap;
`;

export const ShareRow = styled.div`
  display: flex; align-items: center; gap: 10px;
  padding-top: 14px;
  border-top: 1px solid rgba(255,255,255,0.08);
`;

export const ShareLabel = styled.span`
  font-size: 12px; color: rgba(255,255,255,0.4); flex-shrink: 0;
`;

export const ShareBtn = styled.a`
  display: inline-flex; align-items: center; justify-content: center;
  width: 34px; height: 34px;
  border-radius: 8px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.08);
  text-decoration: none;
  position: relative;
  transition: background 0.2s, border-color 0.2s;
  &:hover { background: ${p => p.accent || 'rgba(255,255,255,0.18)'}; border-color: transparent; }
  svg { display: block; }

  &::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    background: #1a1a2e;
    border: 1px solid rgba(255,255,255,0.12);
    color: rgba(255,255,255,0.9);
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 9999;
  }
  &:hover::after { opacity: 1; }
`;

/* ─── Lightbox ───────────────────────────────────────────── */

export const LightboxOverlay = styled.div`
  position: fixed; inset: 0; background: rgba(0,0,0,0.92);
  display: flex; align-items: center; justify-content: center;
  z-index: 3000;
`;

export const LightboxImg = styled.img`
  max-width: 90vw; max-height: 85vh;
  object-fit: contain; border-radius: 8px;
  user-select: none; display: block;
`;

export const LightboxNav = styled.button`
  position: absolute; top: 50%; transform: translateY(-50%);
  ${p => p.prev ? 'left: 16px;' : 'right: 16px;'}
  background: rgba(255,255,255,0.12); border: none; color: #fff;
  font-size: 28px; width: 48px; height: 48px; border-radius: 50%;
  cursor: pointer; display: flex; align-items: center; justify-content: center;
  transition: background 0.2s;
  &:hover { background: rgba(255,255,255,0.25); }
  &:disabled { opacity: 0.2; cursor: default; }
`;

export const LightboxClose = styled.button`
  position: absolute; top: 16px; right: 16px;
  background: rgba(255,255,255,0.12); border: none; color: #fff;
  font-size: 20px; width: 40px; height: 40px; border-radius: 50%;
  cursor: pointer; display: flex; align-items: center; justify-content: center;
  &:hover { background: rgba(255,255,255,0.25); }
`;

export const LightboxDots = styled.div`
  position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%);
  display: flex; gap: 8px;
`;

export const LightboxDot = styled.div`
  width: 8px; height: 8px; border-radius: 50%;
  background: ${p => p.active ? '#fff' : 'rgba(255,255,255,0.35)'};
  transition: background 0.2s; cursor: pointer;
`;



export const VendidoRibbon = styled.div`
  position: absolute;
  top: 12px;
  right: -28px;
  width: 110px;
  background: #e74c3c;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
  padding: 4px 0;
  transform: rotate(45deg);
  z-index: 20;
  letter-spacing: 0.05em;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
`;